/*
 * Returns a shallow copy of the global appConfig attached to the window
 * object by the server.
 * @returns App config object.
 */
function getClientConfig() {
  return { ...window.appConfig };
}
export default getClientConfig;
